/* @ngInject */
const saleAsk = (
  utils,
  valueHandler,
  saleLabels,
  saleRequest,
  toaster,
  saleData,
  updateAllAxletreesModal,
) => {
  const self = {}

  self.delete = async (_id, _back = false) => {
    if (valueHandler.isId(_id.id)) { _id = _id.id }

    if (toaster.confirm(saleLabels.ask.delete)) {
      try {
        const message = await saleRequest.delete(_id)
        toaster.message(message)
        utils.removeFromArray(saleData.mySales, _id)
        if (_back) { utils.$back() }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  self.updateAllAxletrees = async (_saleId) => {
    return updateAllAxletreesModal.open(_saleId)
  }

  return self
}
export default saleAsk



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/services/ask.service.js